export enum ESortDir {    
    Asc,
    Desc
}